
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#00BCD7","d":"M14.38 14a.376.376 0 00.375-.375V12.5h.065c1.069 0 2.077-.637 2.424-1.65a2.472 2.472 0 00-1.646-3.178l-2.77-.792a.963.963 0 01-.698-.924c0-.53.43-.96.96-.96h1.73c.385 0 .755.121 1.06.342.14.103.337.07.459-.057l.534-.534a.38.38 0 00-.046-.572 3.32 3.32 0 00-2.011-.675h-.066V2.375A.376.376 0 0014.375 2h-.75a.376.376 0 00-.375.375V3.5h-.164a2.461 2.461 0 00-2.447 2.695c.094 1.036.89 1.88 1.894 2.166l2.644.755a.963.963 0 01.698.923c0 .53-.431.961-.961.961h-1.73c-.384 0-.754-.122-1.059-.342-.14-.103-.338-.07-.46.056l-.534.534a.38.38 0 00.047.572c.577.441 1.275.68 2.011.68h.066v1.125c0 .206.168.375.375.375h.75zm5.268 12.005c.797 0 1.566-.272 2.185-.77l4.73-3.782c.571-.46.913-1.144.937-1.875a2.519 2.519 0 00-.83-1.94c-.923-.83-2.315-.825-3.276-.057l-2.888 2.311a.5.5 0 01-.314.108h-1.95c.216-.45.305-.97.225-1.514-.187-1.308-1.387-2.236-2.71-2.236H8.999c-.975 0-1.921.314-2.7.9l-1.8 1.35H.875a.376.376 0 00-.375.375v.75c0 .206.169.375.375.375H5l2.198-1.65a3.01 3.01 0 011.8-.6h6.877c.623 0 1.125.502 1.125 1.125S16.498 20 15.875 20H11.75a.752.752 0 00-.75.75c0 .412.337.75.75.75h8.447a2.02 2.02 0 001.251-.436l2.888-2.306c.36-.286.937-.356 1.331 0a.996.996 0 01-.042 1.528L20.9 24.069a1.993 1.993 0 01-1.252.436H.875a.376.376 0 00-.375.375v.75c0 .206.169.375.375.375h18.773z"}})])
          )
        }
      }
    